import React from 'react';
import { galleryCarousel } from '../data/gallery';
interface OrnamentCarouselProps {
  /** Dirección del desplazamiento automático. */
  reverse?: boolean;
  /** Duración del ciclo completo. */
  duration?: string;
  /** Borde de las tarjetas según el fondo de la sección. */
  tone?: 'light' | 'dark';
  className?: string;
}
export function OrnamentCarousel({
  reverse = false,
  duration = '45s',
  tone = 'light',
  className = ''
}: OrnamentCarouselProps) {
  const strip = [...galleryCarousel, ...galleryCarousel];
  const border = tone === 'dark' ? 'border-sage-700' : 'border-gold-200/60';
  return <div className={`overflow-hidden ${className}`} data-id="element-141" data-mp="2xcser2lf13th">
      <ul className={`flex w-max gap-3 sm:gap-5 ${reverse ? 'marquee-track-reverse' : 'marquee-track'}`} style={{
      ['--marquee-duration' as string]: duration
    }} data-id="element-142" data-mp="2xed7qns30ep8">
        {strip.map((photo, i) => {
        const isClone = i >= galleryCarousel.length;
        return <li key={`${photo.image}-${i}`} className={`w-[136px] flex-none overflow-hidden rounded-2xl border bg-bone sm:w-[190px] sm:rounded-3xl lg:w-[230px] ${border}`} data-id="element-143" data-mp="32cwyd1hmeenx" data-mpi={i}>
              <img src={photo.image} alt={isClone ? '' : photo.alt} aria-hidden={isClone || undefined} loading="lazy" className="aspect-square w-full object-cover" data-id="element-144" data-mp="1lyhgyndp1po9" />
            </li>;
      })}
      </ul>
    </div>;
}